import styled, { css } from "styled-components";
import CardNavigationModal from "ui/common/components/feedback/CardNavigationModal/CardNavigationModal";

export const PayModalRoot = styled(CardNavigationModal)(
    () => css`
        height: 100%;
        .inner-card-navigation-body {
            padding-top: 0;
        }
        .main-tabs {
            height: 100%;
        }
    `,
);
